/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import ErrorLayout from './layouts/Error';
import AdminLayout from './layouts/Admin';
import OverviewView from './views/Overview';
import BusinessCard from './views/BusinessCard';
import Cart from './components/BusinessCard/Cart';
import Shell from './layouts/Shell';
import CustomerLayout from './layouts/Customer';
import Payment from './components/BusinessCard/Payment';
export const customerRoutes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/admin/dashboard" />,
  },
  {
    path: '/auth',
    component: () => <Redirect to="/admin/dashboard" />,
  },
  {
    path: '/admin',
    component: CustomerLayout,
    routes: [
      {
        path: '/admin/dashboard/edit',
        component: lazy(() => import('src/views/CardEdit/customer')),
      },
      {
        path: '/admin/dashboard',
        component: lazy(() => import('src/views/CardDetails')),
      },
      {
        path: '/admin/purchase',
        component: lazy(() => import('src/views/Purchase')),
      },
      {
        path: '/admin/profile',
        exact: true,
        component: lazy(() => import('src/views/Profile')),
      },
      {
        path: '/',
        component: () => <Redirect to="/admin/dashboard" />,
      },
    ],
  },
  // redirect to card management
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/401',
        exact: true,
        component: lazy(() => import('src/views/Error401')),
      },
      // {
      //   path: '/errors/404',
      //   exact: true,
      //   component: lazy(() => import('src/views/Error404')),
      // },
      {
        path: '/errors/500',
        exact: true,
        component: lazy(() => import('src/views/Error500')),
      },
      // {
      //   component: () => <Redirect to="/errors/404" />,
      // },
    ],
  },
  {
    path: '/terms-of-service',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/TermsOfService')),
      },
    ],
  },
  {
    path: '/about-us',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/AboutUs')),
      },
    ],
  },
  {
    path: '/:slug/cart',
    exact: true,
    component: Cart,
  },
  // {
  //   path: '/:slug/payment',
  //   exact: true,
  //   component: Payment,
  // },
  {
    path: '/:slug',
    exact: true,
    component: BusinessCard,
  },
  {
    component: () => <Redirect to="/errors/404" />,
  },
];

export const businessRoutes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/admin/overview" />,
  },
  {
    path: '/auth',
    component: () => <Redirect to="/admin/overview" />,
  },

  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/401',
        exact: true,
        component: lazy(() => import('src/views/Error401')),
      },
      {
        path: '/errors/404',
        exact: true,
        component: lazy(() => import('src/views/Error404')),
      },
      {
        path: '/errors/500',
        exact: true,
        component: lazy(() => import('src/views/Error500')),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },

  {
    path: '/admin',
    component: AdminLayout,
    routes: [
      {
        path: '/admin/customers',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementList')),
      },
      {
        path: '/admin/customers/:id',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementDetails')),
      },
      {
        path: '/admin/customers/:id/edit',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementEdit')),
      },

      {
        path: '/admin/overview',
        exact: true,
        component: OverviewView,
      },

      {
        path: '/admin/cards/:id',
        exact: true,
        component: lazy(() => import('src/views/CardDetails')),
      },
      {
        path: '/admin/cards/:id/edit',
        exact: true,
        component: lazy(() => import('src/views/CardEdit')),
      },
      {
        path: '/admin/cards',
        exact: true,
        component: lazy(() => import('src/views/CardsManagementList')),
      },
      {
        path: '/admin/profile',
        exact: true,
        component: lazy(() => import('src/views/Profile')),
      },
      {
        path: '/admin/settings',
        exact: true,
        component: lazy(() => import('src/views/Settings')),
      },
      {
        path: '/admin/purchase',
        component: lazy(() => import('src/views/Purchase')),
      },

      {
        component: () => <Redirect to="/admin/purchase" />,
      },
    ],
  },

  {
    path: '/terms-of-service',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/TermsOfService')),
      },
    ],
  },
  {
    path: '/about-us',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/AboutUs')),
      },
    ],
  },
  {
    path: '/:slug/cart',
    exact: true,
    component: Cart,
  },
  // {
  //   path: '/:slug/payment',
  //   exact: true,
  //   component: Payment,
  // },
  {
    path: '/:slug',
    exact: true,
    component: BusinessCard,
  },
  {
    component: () => <Redirect to="/errors/404" />,
  },
];

// can access auth, cards, info
export const guestRoutes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/auth/login" />,
  },
  {
    path: '/auth',
    component: Shell,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login')),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },

  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/401',
        exact: true,
        component: lazy(() => import('src/views/Error401')),
      },
      {
        path: '/errors/404',
        exact: true,
        component: lazy(() => import('src/views/Error404')),
      },
      {
        path: '/errors/500',
        exact: true,
        component: lazy(() => import('src/views/Error500')),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },

  {
    path: '/terms-of-service',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/TermsOfService')),
      },
    ],
  },
  {
    path: '/about-us',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/AboutUs')),
      },
    ],
  },
  {
    path: '/:slug/cart',
    exact: true,
    component: Cart,
  },
  // {
  //   path: '/:slug/payment',
  //   exact: true,
  //   component: Payment,
  // },
  {
    path: '/:slug',
    exact: true,
    component: BusinessCard,
  },
  {
    component: () => <Redirect to="/auth/login" />,
  },
];

export const adminRoutes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/admin/overview" />,
  },
  {
    path: '/auth',
    component: () => <Redirect to="/admin/overview" />,
  },

  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/401',
        exact: true,
        component: lazy(() => import('src/views/Error401')),
      },
      {
        path: '/errors/404',
        exact: true,
        component: lazy(() => import('src/views/Error404')),
      },
      {
        path: '/errors/500',
        exact: true,
        component: lazy(() => import('src/views/Error500')),
      },
      {
        component: () => <Redirect to="/errors/404" />,
      },
    ],
  },

  {
    path: '/admin',
    component: AdminLayout,
    routes: [
      {
        path: '/admin/customers',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementList')),
      },
      {
        path: '/admin/customers/:id',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementDetails')),
      },
      {
        path: '/admin/customers/:id/edit',
        exact: true,
        component: lazy(() => import('src/views/CustomerManagementEdit')),
      },

      {
        path: '/admin/overview',
        exact: true,
        component: OverviewView,
      },

      {
        path: '/admin/cards/:id',
        exact: true,
        component: lazy(() => import('src/views/CardDetails')),
      },
      {
        path: '/admin/cards/:id/edit',
        exact: true,
        component: lazy(() => import('src/views/CardEdit')),
      },
      {
        path: '/admin/cards',
        exact: true,
        component: lazy(() => import('src/views/CardsManagementList')),
      },
      {
        path: '/admin/settings',
        exact: true,
        component: lazy(() => import('src/views/Settings')),
      },
      {
        path: '/admin/ads',
        exact: true,
        component: lazy(() => import('src/views/AdsList')),
      },
      {
        path: '/admin/ads/:id',
        exact: true,
        component: lazy(() => import('src/views/AdDetails')),
      },
      {
        path: '/admin/profile',
        exact: true,
        component: lazy(() => import('src/views/Profile')),
      },

      {
        component: () => <Redirect to="/admin/overview" />,
      },
    ],
  },

  {
    path: '/terms-of-service',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/TermsOfService')),
      },
    ],
  },
  {
    path: '/about-us',
    component: Shell,
    routes: [
      {
        path: '',
        exact: true,
        component: lazy(() => import('src/views/AboutUs')),
      },
    ],
  },
  {
    path: '/:slug/cart',
    exact: true,
    component: Cart,
  },
  // {
  //   path: '/:slug/payment',
  //   exact: true,
  //   component: Payment,
  // },
  {
    path: '/:slug',
    exact: true,
    component: BusinessCard,
  },
  {
    component: () => <Redirect to="/errors/404" />,
  },
];

const overrides = {
  admin: adminRoutes,
  customer: customerRoutes,
  business: businessRoutes,
  guest: guestRoutes,
};

export default overrides;
